import Backbone from 'backbone';
import ToolbarButton from './ToolbarButton';

export default Backbone.Collection.extend({ model: ToolbarButton });



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/model/Toolbar.js